import script from "./ReportsContent.vue?vue&type=script&setup=true&lang=js"
export * from "./ReportsContent.vue?vue&type=script&setup=true&lang=js"

import "./ReportsContent.vue?vue&type=style&index=0&id=5b11e0f6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5b11e0f6"]])

export default __exports__